.title {
  margin-top: 10px;
  font-weight: bold;
}

.info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.user {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
}
